module.exports = require("isarray");


//////////////////
// WEBPACK FOOTER
// external "isarray"
// module id = 384
// module chunks = 0